var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessThanEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.312 229.213L361.307 349.219C366.135 351.094 371.104 352 375.979 352C391.932 352 406.992 342.406 413.195 326.686C421.305 306.123 411.227 282.902 390.682 274.777L180.936 191.992L390.682 109.209C411.227 101.082 421.305 77.863 413.195 57.299C405.117 36.768 381.932 26.736 361.307 34.768L57.312 154.771C42.031 160.805 32 175.555 32 191.992C32 208.432 42.031 223.182 57.312 229.213ZM408.016 400H39.984C17.902 400 0 417.908 0 439.998V440C0 462.092 17.902 480 39.984 480H408.016C430.098 480 448 462.092 448 440S430.098 400 408.016 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThanEqual);
export default __webpack_public_path__ + "static/media/less-than-equal.e46659e7a8ac42cb63bbd52ad22fba34.svg";
export { ForwardRef as ReactComponent };